// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /chat/list-suggested-people.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeChatListSuggestedPeopleBody,
  typeChatListSuggestedPeopleOutput200,
} from "../../sdk/chat/postChatListSuggestedPeople";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildChatListSuggestedPeopleQueryKey(
  payload: typeChatListSuggestedPeopleBody,
): string[] {
  const queryKeySegments: string[] = [];
  if (typeof payload.query !== "undefined") {
    queryKeySegments.push(`query:${JSON.stringify(payload.query)}`);
  }
  if (typeof payload.limit !== "undefined") {
    queryKeySegments.push(`limit:${JSON.stringify(payload.limit)}`);
  }
  return [
    "post:chat:chatListSuggestedPeople",
    "svc:messaging-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeChatListSuggestedPeopleOutput200,
    unknown,
    typeChatListSuggestedPeopleOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useChatListSuggestedPeople(
  payload: typeChatListSuggestedPeopleBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildChatListSuggestedPeopleQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postChatListSuggestedPeople(payload),
    ...resolvedOptions,
  });
}
